const objectToArray = (obj) => {
  if (obj) return Object.entries(obj).map((e) => e[1]);
  return obj;
};

const normalize = (obj) => {
  return {
    byId: {
      ...obj,
    },
    allIds: objectToArray(obj),
  };
};

const formatFunction = (value) => {
  return Number(parseFloat(Math.round(value * 100) / 100).toFixed(2));
};

const formatRoundNumber = (value) => {
  return value > 999
    ? Number(parseFloat(value / 1000).toFixed(1)) + "K"
    : formatFunction(value);
};

const formatNumber = (value) => {
  return parseFloat(Math.round(value * 100) / 100).toFixed(2);
};

const isUrl = (url) =>
  /[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(url);

const numberWithCommas = (num) => {
  return formatFunction(num)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const splitArrayIntoChunks = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i = i + size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

const setFieldByPath = (object, path, value) => {
  let a = path.split(/[[\].]/).filter((i) => i);
  let o = object;
  for (let i = 0; i < a.length - 1; i++) {
    let n = a[i];
    if (n in o) {
      o = o[n];
    } else {
      o[n] = {};
      o = o[n];
    }
  }
  o[a[a.length - 1]] = value;
};

const getFieldByPath = (object, path) => {
  var a = path.split(/[[\].]/).filter((i) => i);
  var o = object;
  for (var i = 0; i < a.length - 1; i++) {
    var n = a[i];
    if (n in o) {
      o = o[n];
    } else {
      o[n] = {};
      o = o[n];
    }
  }
  return o[a[a.length - 1]];
};

// const calculateDateDifference = (date) => {
//     let diff, res;
//
//     diff = moment().diff(moment(date), 'years');
//     if (diff > 0) {
//         res = diff > 0 ? `${diff} years` : `${diff} year`;
//         res += ' ago'
//     } else {
//         diff = moment().diff(moment(date), 'months');
//         if (diff >= 1) {
//             res = diff > 1 ? `${diff} months` : `${diff} month`;
//             res += ' ago'
//         } else {
//             diff = moment().diff(moment(date), 'weeks');
//             if (diff > 0) {
//                 res = diff > 1 ? `${diff} weeks` : `${diff} week`;
//                 res += ' ago'
//             } else {
//                 diff = moment().diff(moment(date), 'days');
//                 if (diff > 0) {
//                     res = diff > 1 ? `${diff} days` : `${diff} day`;
//                     res += ' ago'
//                 } else {
//                     res = 'Today';
//                 }
//             }
//         }
//     }
//     return res;
// }

const searchList = (inputValue = "", array) => {
  return array.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));
};

const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
  }
};

const hideContextMenu = (e) => {
  if (e.button === 2) {
    e.preventDefault();
    return false;
  }
};

const ILTimeZones = [66];
const UKTimeZones = [48];
const AUTimeZones = [108, 111, 117, 118, 119, 120, 124, 128];
const USTimeZones = [4, 6, 11, 14, 16, 22, 28, 139, 141];
const TimeZonesMap = {
  1: ILTimeZones,
  2: UKTimeZones,
  3: AUTimeZones,
  4: USTimeZones,
};

export {
  normalize,
  objectToArray,
  isUrl,
  numberWithCommas,
  splitArrayIntoChunks,
  setFieldByPath,
  getFieldByPath,
  formatNumber,
  formatRoundNumber,
  // calculateDateDifference,
  searchList,
  scrollToElement,
  hideContextMenu,
  TimeZonesMap,
};
